import { useScroll } from "ahooks";
import { Link } from "react-router";
import { footerNavigation } from "@/content/navigation";
import { site } from "@/content/site";
import { Container } from "@/components/ui/Container";
import { Logo } from "./Logo";

export function Footer() {
  const scroll = useScroll();

  return (
    <footer className="bg-brand-950 pt-16 pb-10 text-brand-100">
      <Container>
        <div className="grid gap-12 lg:grid-cols-[1.2fr_2fr]">
          <div>
            <div className="text-white">
              <Logo tone="light" />
            </div>
            <p className="mt-5 max-w-sm">
              Agentic Plus organizes evidence, creative production, approvals, and learning into
              trackable growth missions for brands and agencies.
            </p>
            <p className="mt-5">
              <a className="font-semibold text-mint hover:text-white" href={`mailto:${site.email}`}>
                {site.email}
              </a>
            </p>
            <p className="mt-1 text-sm">agenticplus.dev</p>
          </div>

          <nav className="grid gap-8 sm:grid-cols-3" aria-label="Footer">
            {footerNavigation.map((group) => (
              <div key={group.title}>
                <h2 className="text-sm font-bold uppercase tracking-wide text-white">
                  {group.title}
                </h2>
                <ul className="mt-4 space-y-3">
                  {group.links.map((link) => (
                    <li key={link.href}>
                      <Link
                        className="inline-flex min-h-8 items-center hover:text-white"
                        to={link.href}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </div>

        <div className="mt-12 flex flex-col justify-between gap-4 border-t border-white/10 pt-6 text-sm md:flex-row">
          <p>© {new Date().getFullYear()} Agentic Plus. All rights reserved.</p>
          <p>Last reviewed: {site.lastReviewed}</p>
        </div>
      </Container>

      {scroll && scroll.top > 480 ? (
        <button
          type="button"
          className="fixed bottom-5 right-5 z-40 inline-flex min-h-11 items-center rounded-full bg-mint px-5 font-bold text-brand-950 shadow-lg"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          Back to top
        </button>
      ) : null}
    </footer>
  );
}
